/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KostenstelleDto } from '../../models/kostenstelle-dto';

export interface GetKostenstellen$Json$Params {
}

export function getKostenstellen$Json(http: HttpClient, rootUrl: string, params?: GetKostenstellen$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KostenstelleDto>>> {
  const rb = new RequestBuilder(rootUrl, getKostenstellen$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<KostenstelleDto>>;
    })
  );
}

getKostenstellen$Json.PATH = '/v1/kostenstellen';
